import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable react/require-default-props */
import React from 'react';
import { arrayOf, bool, element, node, oneOf, oneOfType, string } from 'prop-types';
import classNames from 'classnames';
import Icon from '../icon';
import styles from './dropdown-trigger.module.less';
var displayName = 'DropdownTrigger';
var propTypes = {
  block: bool,
  fullWidth: bool,
  children: oneOfType([node, element, arrayOf(element)]),
  disabled: bool,
  error: bool,
  mode: oneOf(['select', 'button']),
  className: string
};
var defaultProps = {
  mode: 'select'
};
/**
 * Provides the basic structure of the face of a `Select` component
 */

var DropdownTrigger = function DropdownTrigger(_ref) {
  var _classNames, _classNames2;

  var block = _ref.block,
      children = _ref.children,
      disabled = _ref.disabled,
      error = _ref.error,
      mode = _ref.mode,
      className = _ref.className,
      fullWidth = _ref.fullWidth,
      otherProps = _objectWithoutProperties(_ref, ["block", "children", "disabled", "error", "mode", "className", "fullWidth"]);

  var Container = mode;
  var containerClasses = classNames(styles.container, (_classNames = {}, _defineProperty(_classNames, styles.inline, !block), _defineProperty(_classNames, styles.block, block), _defineProperty(_classNames, styles.fullWidth, block || fullWidth), _classNames));
  var triggerClasses = classNames(className, styles.trigger, styles[mode], (_classNames2 = {}, _defineProperty(_classNames2, styles.default, !error && !disabled), _defineProperty(_classNames2, styles.error, error), _defineProperty(_classNames2, styles.disabled, disabled), _defineProperty(_classNames2, styles.fullWidth, block || fullWidth), _classNames2));
  return React.createElement("div", {
    className: containerClasses
  }, React.createElement(Container, _extends({}, otherProps, {
    disabled: disabled,
    className: triggerClasses
  }), children), React.createElement(Icon, {
    className: styles.icon
  }));
};

DropdownTrigger.displayName = displayName;
DropdownTrigger.propTypes = propTypes;
DropdownTrigger.defaultProps = defaultProps;
export default DropdownTrigger;